import { SITE_URL } from "./site";

function upsertMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    if (attrs.name) el.setAttribute("name", attrs.name);
    if (attrs.property) el.setAttribute("property", attrs.property);
    if (attrs.rel) el.setAttribute("rel", attrs.rel);
    document.head.appendChild(el);
  }
  if (attrs.content !== undefined) el.setAttribute("content", attrs.content);
  if (attrs.href !== undefined) el.setAttribute("href", attrs.href);
}

export function applyPageMeta(title, description, path) {
  document.title = title;
  const url = SITE_URL + path;
  upsertMeta('meta[name="description"]', { name: "description", content: description });
  upsertMeta('link[rel="canonical"]', { rel: "canonical", href: url });
  upsertMeta('meta[property="og:title"]', { property: "og:title", content: title });
  upsertMeta('meta[property="og:description"]', { property: "og:description", content: description });
  upsertMeta('meta[property="og:url"]', { property: "og:url", content: url });
  upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
  upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
}
